import * as Yup from "yup";

const projectEmailSchema = Yup.string().email("Invalid email").required("Email is required");

// Match the validation used by the form so missing/invalid account emails
// are surfaced before the user tries to submit an uneditable hidden field.
export const getProjectCustomerEmailIssue = (email) => {
  if (!String(email ?? "").trim()) return "missing";
  return projectEmailSchema.isValidSync(email) ? null : "invalid";
};

export const createProjectValidationSchema = Yup.object({
  projectName: Yup.string()
    .trim()
    .min(3, "Name is too short")
    .required("Project Name is required"),
  eventType: Yup.string().required("Event Type is required"),
  order_id: Yup.string().required("Order ID is required"),
  attachedCustomers: Yup.array().min(1, "Customer is required"),
  email: projectEmailSchema,
  phone: Yup.string().nullable().notRequired(),
  order_status: Yup.string().required("Order status is required"),
});
